/**
 * @packageDocumentation
 * @module api.functional.companies.invitations
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";
import type { tags } from "typia";

import type { CompanyInvitesDto } from "../../../structures/CompanyInvitesDto";
import type { InvitationResultDto } from "../../../structures/InvitationResultDto";
import type { InvitationRoleDto } from "../../../structures/InvitationRoleDto";

/**
 * @controller CompanyExternalController.inviteToCompany
 * @path POST /companies/:QBOId/invitations
 * @accessor api.functional.companies.invitations.inviteToCompany
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function inviteToCompany(
  connection: IConnection,
  QBOId: number,
  body: inviteToCompany.Body,
): Promise<inviteToCompany.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...inviteToCompany.METADATA,
      template: inviteToCompany.METADATA.path,
      path: inviteToCompany.path(QBOId),
    },
    body,
  );
}
export namespace inviteToCompany {
  export type Body = CompanyInvitesDto;
  export type Output = {
    invitations: InvitationResultDto[];
  };

  export const METADATA = {
    method: "POST",
    path: "/companies/:QBOId/invitations",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = (QBOId: number) =>
    `/companies/${encodeURIComponent(QBOId?.toString() ?? "null")}/invitations`;
}

/**
 * @controller CompanyExternalController.setInvitationRole
 * @path PATCH /companies/:QBOId/invitations/:invitationId
 * @accessor api.functional.companies.invitations.setInvitationRole
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function setInvitationRole(
  connection: IConnection,
  QBOId: number,
  invitationId: string,
  body: setInvitationRole.Body,
): Promise<setInvitationRole.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...setInvitationRole.METADATA,
      template: setInvitationRole.METADATA.path,
      path: setInvitationRole.path(QBOId, invitationId),
    },
    body,
  );
}
export namespace setInvitationRole {
  export type Body = InvitationRoleDto;
  export type Output = {
    id: string;
    role: "STAFF" | "MANAGER";
    expiresAt: string & tags.Format<"date-time">;
  };

  export const METADATA = {
    method: "PATCH",
    path: "/companies/:QBOId/invitations/:invitationId",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (QBOId: number, invitationId: string) =>
    `/companies/${encodeURIComponent(QBOId?.toString() ?? "null")}/invitations/${encodeURIComponent(invitationId?.toString() ?? "null")}`;
}

/**
 * @controller CompanyExternalController.revokeInvitation
 * @path DELETE /companies/:QBOId/invitations/:invitationId
 * @accessor api.functional.companies.invitations.revokeInvitation
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function revokeInvitation(
  connection: IConnection,
  QBOId: number,
  invitationId: string,
): Promise<revokeInvitation.Output> {
  return PlainFetcher.fetch(connection, {
    ...revokeInvitation.METADATA,
    template: revokeInvitation.METADATA.path,
    path: revokeInvitation.path(QBOId, invitationId),
  });
}
export namespace revokeInvitation {
  export type Output = {
    ack: true;
  };

  export const METADATA = {
    method: "DELETE",
    path: "/companies/:QBOId/invitations/:invitationId",
    request: null,
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 200,
  } as const;

  export const path = (QBOId: number, invitationId: string) =>
    `/companies/${encodeURIComponent(QBOId?.toString() ?? "null")}/invitations/${encodeURIComponent(invitationId?.toString() ?? "null")}`;
}
